import { Box, Button, Stack, useTheme } from '@rabex-kit/rabex-ui';
import {
  ArrowsUpdate,
  ChartFin,
  ChartRelation,
  ControlsCloseSmall,
  FilesCase,
  GenericHome,
  MailFlag
} from '@heathmont/moon-icons-tw';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../Icon';
import Logo from '../../static/images/svg/kyc/Logo.svg';
import LogoDark from '../../static/images/svg/kyc/Logo-Dark.svg';
import MobileMenu, { MenuItem } from '../DrawerMenuItems';
import {
  DASHBOARD,
  LOGIN,
  OTC,
  P2P_STATIC,
  REGISTER
} from '../../pages/routes';

type AuthDrawerMenuProps = {
  onClose?: () => void;
};

// Clear menu structure: each menu can have EITHER submenu OR children
const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    title: 'خانه',
    icon: <GenericHome />,
    link: DASHBOARD
  },
  {
    id: 'exchange',
    title: 'معامله',
    icon: <ArrowsUpdate />,
    // badge: '5',
    submenu: [
      {
        id: 'otc',
        title: 'تبدیل سریع',
        icon: <ChartRelation />,
        link: OTC
      },
      {
        id: 'p2p',
        title: 'معامله حرفه‌ای',
        icon: <ChartFin />,
        link: `${P2P_STATIC}/USDTTMN`
      }
    ]
  },
  {
    id: 'guide',
    title: 'آموزش',
    icon: <FilesCase />,
    submenu: [
      {
        id: 'academy',
        title: 'آکادمی رابکس',
        icon: <FilesCase />,
        link: '/'
      },
      {
        id: 'help',
        title: 'راهنما',
        icon: <MailFlag />,
        link: `$/`
      }
    ]
  }
  /* // Another children example
  {
    id: 'analytics',
    title: 'گزارشات',
    icon: <TrendingUpIcon />,
    children: (
      <Stack p={2}>
        <Typography variant="subtitle2" gutterBottom>
          گزارش سریع
        </Typography>
        <Box sx={{
          height: 100,
          backgroundColor: 'primary.light',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Typography color="primary.contrastText">
            نمودار فروش
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} mt={2}>
          <Button size="small" variant="outlined">مشاهده جزئیات</Button>
          <Button size="small" variant="contained">دانلود گزارش</Button>
        </Stack>
      </Stack>
    )
  }, */
];

const AuthDrawerMenu = ({ onClose }: AuthDrawerMenuProps) => {
  const { palette } = useTheme();
  const navigate = useNavigate();
  return (
    <Stack sx={{ height: '100vh' }} justifyContent="space-between">
      {/* Logo Section */}
      <Stack>
        <Stack
          px={4}
          py={3}
          alignItems="center"
          justifyContent="space-between"
          flexDirection="row"
          sx={{ borderBottom: `1px solid ${palette.base[200]}` }}>
          <Icon size={32} onClick={() => onClose && onClose()}>
            <ControlsCloseSmall />
          </Icon>
          <Box onClick={() => navigate(LOGIN)}>
            <img
              src={palette.mode === 'light' ? Logo : LogoDark}
              alt="logo"
              height={32}
            />
          </Box>
        </Stack>
        {/* Search Section */}
        {/* <Stack p={4} justifyContent="center" alignItems="center">
        <Input
          ref={searchInputRef}
          color="primary"
          placeholder="جستجو"
          size="md"
          sx={{
            height: 40,
            width: '90vw'
          }}
          value={searchTerm}
          onChange={handleSearch}
          startAdornment={
            <InputAdornment
              sx={{
                width: 24,
                height: 24,
                color: palette.base.A80
              }}
              position="start">
              <Search />
            </InputAdornment>
          }
          endAdornment={
            searchTerm ? (
              <IconButton
                sx={{ width: 24, height: 24 }}
                onClick={() => {
                  setSearchTerm('');
                  setMobileSearchInputOpen(false);
                }}>
                <Close />
              </IconButton>
            ) : undefined
          }
        />
      </Stack> */}
        <MobileMenu items={menuItems} />
      </Stack>
      <Stack p={4} gap={3} flexDirection="row">
        <Button
          variant="containedSecondary"
          size="md"
          fullWidth
          onClick={() => navigate(LOGIN)}>
          ورود
        </Button>
        <Button
          variant="contained"
          size="md"
          fullWidth
          onClick={() => navigate(REGISTER)}>
          ثبت نام
        </Button>
      </Stack>
    </Stack>
  );
};
export default AuthDrawerMenu;
